exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".my-drop-zone {\n  border: dashed 5px lightgray;\n  width: 100%;\n  text-align: center;\n  padding: 25px 12px;\n  line-height: auto;\n  height: auto;\n  cursor: pointer; }\n\n.nv-file-over {\n  border: dashed 5px green; }\n\n.disabled {\n  opacity: 0.5; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/admin/shared/file-drop/file-drop.component.scss
// module id = 263
// module chunks = 0 1